
/**
 * Used to find all projects with the same business_id as the given projectId.
 * @param {string[]} projectIds The array containing original projectId
 * @param {string[]} businessIds Array of businessIds
 * @param {Object[]} allProjects Array of project objects
 *
 */
export default function returnProjectIdAndBusinessProjectIds(
  projectIds,
  businessIds,
  allProjects
) {

  if (!allProjects || !allProjects.length) {
    return projectIds;
  }

  let children = Object.values(allProjects)
    .filter((project) => businessIds.includes(project.business_id))
    .map((project) => project.id);
  if (children.length > 0) {
    const nextChildren = returnProjectIdAndBusinessProjectIds(
      children,
      allProjects
    );
    return [...projectIds, ...nextChildren];
  }
  return [...projectIds, ...children];
}
